import ApplicationController from '../application_controller'

export default class extends ApplicationController {

	static targets = [
		'meritInput',
		'quantityInput',
		'quantityLabel',
		'deleteButton',
		'helpTextElement',
		'helpTextLabel',
	]

	connect() {
		const checkedOption = this.meritInputTarget.querySelector('option:checked')
		if (checkedOption && checkedOption.dataset.customProperties) {
			const choiceProperties = JSON.parse(checkedOption.dataset.customProperties)
			const requireQuantity = choiceProperties.requireQuantity
			const quantityName = choiceProperties.quantityName
			const helpText = choiceProperties.helpText
			this.updateQuantityInput(requireQuantity, quantityName)
			this.updateHelpText(helpText)
		} else {
			this.updateQuantityInput()
			this.updateHelpText()
		}
	}

	updateMeritId(event) {
		if (event && event.detail && event.detail.choice) {
			const choiceProperties = event.detail && event.detail.choice.customProperties
			const requireQuantity = choiceProperties.requireQuantity
			const quantityName = choiceProperties.quantityName
			const helpText = choiceProperties.helpText
			this.updateQuantityInput(requireQuantity, quantityName)
			this.updateHelpText(helpText)
		} else {
			this.updateQuantityInput()
			this.updateHelpText()
		}
	}

	// This will restrict removing the last Merit Input because there must be at least one.
	updateRemoveButtons() {
		if (this.meritInputTargets.length > 1) { // show all remove buttons
			for (const button of this.deleteButtonTargets) {
				button.classList.remove('d-none')
			}
		}
		else { // hide the last delete button
			for (const button of this.deleteButtonTargets) {
				button.classList.add('d-none')
			}
		}
	}

	updateQuantityInput(requireQuantity, quantityName) {
		if (requireQuantity) {
			this.quantityLabelTarget.innerHTML = quantityName
			this.quantityInputTarget.classList.remove('d-none')
		} else {
			this.quantityInputTarget.classList.add('d-none')
		}
	}

	updateHelpText(helpText) {
		if (helpText) {
			this.helpTextElementTarget.classList.remove('d-none')
			this.helpTextLabelTarget.innerHTML = helpText
		} else {
			this.helpTextElementTarget.classList.add('d-none')
		}

	}

	deleteMeritInput(event) {
		this.element.remove()
	}

}

